import React from 'react'
import Cookies from 'js-cookie'
import "./Cookies.css"
import Navbar from './Navbar'


const CookiesPage = () => {
    const handleRemoveCookies = () => {
        Cookies.remove("cookieConsent")
        alert("Souhlas s cookies byl odstraněn.")
    }
  return <main>
  <Navbar />
  <div className="business-container">
    <h2 className="services-title">Jaké cookies zpracováváme</h2>
    <h3 className="podnadpis">Na našem webu používáme následující cookies:</h3>

    <h3 className="podnadpis">1. Cookie pro souhlas s cookies</h3>
    <p className="text">
      Tato cookie pamatuje, zda uživatel souhlasil s používáním cookies na našem webu. Pokud uživatel souhlasí, cookie je nastavena na 365 dní a zabraňuje opakovanému zobrazení banneru pro souhlas.
    </p>

    <h3 className="podnadpis">2. Sledovací cookies</h3>
    <p className="text">
      Shromažďují anonymizované informace o tom, jak uživatelé interagují s naším webem, což nám pomáhá analyzovat výkon stránek a zlepšovat uživatelský zážitek. Tyto cookies jsou využívány k monitorování chování uživatelů a výkonu stránek (např. Google Analytics).
    </p>

    <h3 className="podnadpis">3. Funkční cookies</h3>
    <p className="text">
      Tato cookies zajišťují základní funkce webu, jako je zapamatování přihlášení nebo jazykového nastavení. Funkce těchto cookies nejsou nezbytné, ale umožňují lepší uživatelský zážitek.
    </p>

    <p className="text">
      Pokud nesouhlasíte s používáním cookies, můžete nastavit svůj prohlížeč tak, aby cookies odmítal. Mějte na paměti, že pokud cookies zakážete, některé funkce webu nemusí fungovat správně.
    </p>

    <button className="profile-button" onClick={handleRemoveCookies}>
      Odebrat cookies
    </button>
  </div>
</main>
}

export default CookiesPage